import type { Variables, Cache, UpdatesConfig } from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

import type { PressCreateMutation } from '@/graphql/generated/graphql';

const pressMutations: UpdatesConfig['Mutation'] = {
  pressCreate: (data: PressCreateMutation, __: Variables, cache: Cache) => {
    if (data.pressCreate) {
      invalidateQuery('presses', cache);
    }
  },
};

export default pressMutations;
